import React, { useState } from "react";
import { Button, Card, Form, Modal } from "react-bootstrap";
import { getCms, updateCms } from "../../api/authService";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import DataTable from "react-data-table-component";
import { Icon } from "@iconify/react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

export default function AllPages() {
  const [searchText, setSearchText] = useState("");
  const [title, setTitle] = useState("");
  const [value, setValue] = useState("");
  const [editShow, setEditShow] = useState(false);
  const [deleteShow, setDeleteShow] = useState(false);
  const [selectedType, setSelectedType] = useState(null);

  const EditToggle = () => setEditShow(!editShow);
  const DeleteToggle = () => setDeleteShow(!deleteShow);

  const handleEdit = async (type) => {
    try {
      const response = await getCms({ type });
      if (response?.status) {
        setTitle(response.data.title);
        setValue(response.data.content);
        setSelectedType(type);
        setEditShow(true);
      } else {
        toast.error("CMS data not found.");
      }
    } catch (error) {
      console.error("Error fetching CMS:", error);
      toast.error(error.message || "Error fetching CMS content");
    }
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        type: selectedType,
        title,
        content: value,
      };

      const response = await updateCms(payload);
      if (response?.success === true || response?.status === true) {
        toast.success("Page updated successfully!");
        setEditShow(false);
      } else {
        toast.error("Failed to update CMS content.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error(error.message || "Error updating CMS");
    }
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link className="btnedit me-2" onClick={() => handleEdit(row.type)}>
            <Icon icon="tabler:pencil" />
          </Link>
          <Link className="btndelete" onClick={DeleteToggle}>
            <Icon icon="tabler:trash" />
          </Link>
        </>
      ),
    },
  ];

  const data = [
    {
      id: 1,
      name: "About Us",
      date: "05 June 2025",
      type: "aboutus",
    },
    {
      id: 2,
      name: "Privacy Policy",
      date: "05 June 2025",
      type: "privacy",
    },
    {
      id: 3,
      name: "Terms & Conditions",
      date: "05 June 2025",
      type: "terms",
    },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <Card>
        <Card.Header className="py-4">
          <h5>All Pages</h5>
        </Card.Header>
        <Card.Body className="bookingtable mt-3">
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="searchfield"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            responsive
            className="custom-table"
            noDataComponent={<p className="text-center my-4">No pages found</p>}
          />
        </Card.Body>
      </Card>

      {/* Edit Modal */}
      <Modal size="lg" show={editShow} onHide={EditToggle} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="modalhead">Edit Page</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <ReactQuill
                className="EditpageEditor"
                theme="snow"
                value={value}
                onChange={setValue}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            className="btn btn-primary px-4 min_width140"
            onClick={handleUpdate}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Modal */}
      <Modal
        className="modal_Delete"
        show={deleteShow}
        onHide={DeleteToggle}
        centered
      >
        <Modal.Body>
          <div className="modaldelete_div text-center">
            <Icon className="delete_icon mb-2" icon="gg:close-o" />
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <div className="text-center">
            <Button
              onClick={DeleteToggle}
              className="btn btn-outline-primary px-4 me-3"
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary px-4 min_width110"
              onClick={DeleteToggle}
            >
              Ok
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
